import React, { useEffect, useMemo } from "react";
import NProgress from "../../libraries/progress";
import { gettext, cropr } from "../../adapter";
import NoRights from "./NoRights";
import LoadError from "../LoadError";
import Loader from "../Loader";
import WeatherForecastRegions from "./WeatherForcastRegions";
import WeatherForecastOverview from "./WeatherForecastOverview";
import SprayingForecast from "./SprayingForecast";
import Radar from "./Radar";
import WeatherForecastCharts from "./WeatherForecastCharts";
import WeatherForecastTables from "./WeatherForecastTables";
import { useDispatch, useSelector } from "react-redux";
import { fetchRegions } from "../../actions/weatherRegionsActions";
import { parseRegions } from "../../utils/weatherForecastUtils";

const WeatherForecast = ({ apiUrl }) => {
  const dispatch = useDispatch();

  const regionsState = useSelector((state) => {
    return state.weatherRegions;
  });

  const regions = useMemo(() => {
    const regions = parseRegions(regionsState.items);

    // Get the selected station
    var selectedRegion;
    if (!regionsState.isFetching && regions.length > 0) {
      selectedRegion = regions.find((item) => {
        return item.id === regionsState.selectedRegion;
      });
    }
    return { ...regionsState, items: regions, selectedRegion };
  }, [regionsState]);

  useEffect(() => {
    NProgress.start();
    dispatch(fetchRegions(apiUrl));
  }, [dispatch, apiUrl]);

  if (regions.isFetching === true) {
    return <Loader message={gettext("Retrieving weather forecast...")} />;
  }

  if (!cropr.features.weather_forecast) {
    NProgress.done();
    return <NoRights message={gettext("Demo weather forecast data")} image_class="weather" />;
  }

  if (!regions.items && regions.loadError) {
    NProgress.done();
    return <LoadError />;
  }

  NProgress.done();

  return (
    <div>
      <WeatherForecastRegions
        apiUrl={apiUrl}
        regions={regions.items}
        selectedRegion={regions.selectedRegion}
      />
      <WeatherForecastOverview />
      <SprayingForecast />
      <Radar />
      <WeatherForecastCharts />
      <WeatherForecastTables />
    </div>
  );
};

export default WeatherForecast;
